import TimelineAnnotationGroupSchema from 'schemas/TimelineAnnotationGroupSchema'

export default function TimelineAnnotationGroupVo(initData = {}) {
  return TimelineAnnotationGroupSchema.validateSync(initData)
}
